import type { Player, Product } from "@repo/shared-types";
import { atomWithStorage } from "jotai/utils";

export const playerAtom = atomWithStorage<Player | string | null>(
  "player",
  null
);
export const productsAtom = atomWithStorage<Product[]>("products", []);
